import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transports_min', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        shortList: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transports_min', {
                params: {
                    isShortHaul: 0,
                },
            })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        regenerate: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('export_loads', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        routes: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('routes', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        groups: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('categories', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouses_micro', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        route_dest: (cntx, id) => new Promise((resolve, reject) => {
            axios.get(`route_dest/${id}?sourceType=0`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`transports/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('transports', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        transportDriver: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('transdriver', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        find_route: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('find_route', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`transports/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        changeStatus: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`change_status/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`transports/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        transdriver: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transdriver', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        transporters: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transporters', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        markets: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('markets?isShortHaul=true', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        sales: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('sales', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
